module.exports = __webpack_public_path__ + "img/taxOnlineChangeAct.06678f48.png";